import type { ApolloError } from '@apollo/client'
import { DUPLICATE_FILTER_ERROR_CODES } from '@doss/common-all'

const DUPLICATE_FILTER_ERROR_CODE_SET = new Set<string>(Object.values(DUPLICATE_FILTER_ERROR_CODES))

/** Returns the actionable backend message for errors specific to duplicate filtering. */
export const getDuplicateFilterErrorMessage = (error: ApolloError): string | undefined => {
  return error.graphQLErrors.find(
    (graphQLError) =>
      typeof graphQLError.extensions?.errCode === 'string' &&
      DUPLICATE_FILTER_ERROR_CODE_SET.has(graphQLError.extensions.errCode),
  )?.message
}
